import React from 'react';
import PropTypes from 'prop-types';

import { CheckboxContainer, CheckboxWindow, CheckboxLabel } from "./styles";

const Checkbox = ({ name, value, id, checked, onChange, label, description, readonly, blue, normal, invalid, checkboxToRight, radio }) => (
  <CheckboxContainer blue={blue}>
    <input
      type="checkbox"
      name={name}
      value={value}
      id={id}
      checked={checked}
      onChange={onChange}
      hidden
      readOnly={readonly}
    />
    <CheckboxLabel htmlFor={id} normal={normal} checkboxToRight={checkboxToRight}>
      <CheckboxWindow blue={blue} invalid={invalid} radio={radio} />
      <span>
        {label}
        {description && <p>{description}</p>}
      </span>
    </CheckboxLabel>
  </CheckboxContainer>
);

Checkbox.propTypes = {
  name: PropTypes.string.isRequired,
  checkboxToRight: PropTypes.bool,
  value: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  checked: PropTypes.oneOfType([PropTypes.string, PropTypes.bool]),
  onChange: PropTypes.func,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.instanceOf(Object)]),
  description: PropTypes.string,
  readonly: PropTypes.bool,
  blue: PropTypes.bool,
  normal: PropTypes.bool,
  invalid: PropTypes.bool,
  radio: PropTypes.bool,
};

export default Checkbox;
